module.exports = __webpack_public_path__ + "img/company_caseelven.647ea245.png";